import { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  Button,
  CircularProgress,
  // ListItem,
  // ListItemButton,
  styled,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
// import { useMutation } from "react-query";
import {
  getAllDepattment,
  getDoctorsByDepartment,
  getTimeSlotes,
} from "./services";
import { FormOnChangeEventType } from "../../../EMR/types";
import { getVisitType } from "../../../EMR/services";
import {
  BookingFormType,
  prepareBookingParams,
  SaveParamsType,
  VisitTypesType,
} from "./types";
import moment from "moment";
import { useMutation, useQuery } from "react-query";

import { calculateAge } from "../../../utilis/methods/dateMethods";
import {
  parseToLocal,
} from "../../../utilis/methods/localDateTime";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import usePopup from "../../../hooks/usePopup";
import { getCountry } from "../../Patientregistration/v2/registrationServices";
import { getCountryCodeForBooking } from "./countryCodeUtils";
import useBookingSave from "./apiHooks";
import PatientSearch from "./PatientSearch";
import { PatientBookingContext } from "./context/PatientBookingProvider";
import useAuthentication from "@hooks/useAuthentication";
dayjs.extend(utc);
const gap = "gap-4";
const grid = `grid sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 ${gap} p-4`;
const StyledTextField = styled("div")(({ }) => ({
  "& .MuiTextField-root": {
    "& .MuiOutlinedInput-root": {
      borderTopLeftRadius: 5,
      borderBottomLeftRadius: 5,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      width: 110,
      paddingX: 0,
    },
  },
  // },
}));



const StyledSelect = styled("div")(({ }) => ({
  "& .MuiFormControl-root": {
    "& .MuiOutlinedInput-root": {
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      borderTopRightRadius: 5,
      borderBottomRightRadius: 5,
      borderLeft: 0,
      // "& fieldset": {
      //   borderLeftWidth: 0,
      // },
    },
  },
  // },
}));

function BookingForm() {
  // const {mutate:getPatientData}=useMutation()
  const theme = useTheme();
  const { showSnackbar } = usePopup();
  // const [withSlot, setWithSlot] = useState(false);
  const { handleSubmit, control, reset, watch, setValue } = useForm<BookingFormType>();
  const { timeSlot, setOpen, editDetails, bookingSearchParam, setEditDetails, open } =
    useContext(PatientBookingContext);
  const [dobType, setDobType] = useState<string>("");
  const [selectedDate, setSelectedDate] = useState<{
    startDate: string | null;
    endDate: string | null;
  }>({
    startDate: "",
    endDate: "",
  });
  const {
    mutate: fetchAllDepattment,
    data: department,
    isLoading: departmentLoading,
  } = useMutation(getAllDepattment);
  const {
    mutate: fetchDoctorsByDepartment,
    data: doctors,
    isLoading: doctorsLoading,
  } = useMutation(getDoctorsByDepartment);

  const {
    mutate: fetchTimeSlot,
    data: timeSlots,
    isLoading: timeSlotLoading,
  } = useMutation(getTimeSlotes);

  const {
    data: countries,
    isLoading: countryLoading,
  } = useQuery(["getCountryBooking"], getCountry, {
    refetchOnWindowFocus: false,
  });

  const {
    mutate: fetchVisitType,
    data: visitType,
    isLoading: visitTypesLoading,
  } = useMutation(getVisitType);
  const { mutate: save, isLoading: saveLoading } = useBookingSave();

  const isDateLocked = Boolean(timeSlot.startTime);

  <TextField
    label="Date"
    value={moment
      .utc(timeSlot.startTime || editDetails?.start)
      .format("DD-MM-YYYY (dddd)")}
    InputProps={{
      readOnly: true,
    }}
    disabled={isDateLocked}
  />

  function onSubmit(value: BookingFormType) {
    const temporaryBooking = isTemporaryBooking ? 1 : 0;

    console.log("temporaryBooking---->", temporaryBooking, editDetails?.temporaryBooking, isTemporaryBooking);



    let params: SaveParamsType;


    if (Boolean(editDetails)) {

      params = prepareBookingParams({
        ...editDetails,
        ...value,
        temporaryBooking,
        countryCodeId: value.countryCode?.id
          ? Number(value.countryCode.id)
          : editDetails?.countryCodeId ?? undefined,
      });
      if (
        timeSlot.slotType == "dayGridMonth" ||
        timeSlot.slotType == "multiMonthYear"
      ) {
        const inValidTime =
          moment.utc(params.appStartTime).format("HH:mm:ss") == "00:00:00";
        const isAfter = moment
          .utc(params.appEndTime)
          .isAfter(moment.utc(params.appStartTime), "minute");
        if (!isAfter) {
          showSnackbar({
            message: "End time must be later than the start time.",
            open: true,
            variant: "warning",
            duration: 2000,
          });
          return;
        }
        if (inValidTime) {
          showSnackbar({
            message: "Please select a valid start time !",
            open: true,
            variant: "warning",
            duration: 2000,
          });
          return;
        }
        save(params);
        console.log(params);
      } else {
        save(params);
        console.log(params);
      }
    } else {
      params = prepareBookingParams({ ...value, temporaryBooking });
      if (
        timeSlot.slotType == "dayGridMonth" ||
        timeSlot.slotType == "multiMonthYear"
      ) {
        const inValidTime =
          moment.utc(params.appStartTime).format("HH:mm:ss") == "00:00:00";
        const isAfter = moment
          .utc(params.appEndTime)
          .isAfter(moment.utc(params.appStartTime), "minute");
        if (!isAfter) {
          showSnackbar({
            message: "End time must be later than the start time.",
            open: true,
            variant: "warning",
            duration: 2000,
          });
          return;
        }
        if (inValidTime) {
          showSnackbar({
            message: "Please select a valid start time !",
            open: true,
            variant: "warning",
            duration: 2000,
          });
          return;
        }
        save(params);
      } else {
        save(params);
      }
    }
  }

  const checkTimeOfDoctor = (departmentId: number) => {
    // const startDate = timeSlot.startTime
    //       ? timeSlot.startTime
    //       : editDetails?.startDate;
    const formData = watch();
    const startDate = dayjs.utc(formData.startDate);
    fetchDoctorsByDepartment({
      dayId: dayjs(startDate).day(),
      departmentId,
      selectedTime: dayjs(startDate).format("hh:mm:ss"),
    });
  };

  const onChange = (e: FormOnChangeEventType) => {
    const { target } = e;
    if (target.name == "department") {
      if (timeSlot.lockedDepartment) return;
      checkTimeOfDoctor(target?.value?.departmentId || 0);
      reset({
        ...watch(),
        doctor: null,
        timeSlot: null,
      })
    }
    if (target.name == "dob") {
      const allData = watch();
      if (!target.value) {
        reset({
          ...allData,
          age: "",
        });
        setDobType("");
        return;
      }
      const calculatedAge = calculateAge(target.value);
      reset({
        ...allData,
        age: calculatedAge.age.toString(),
      });
      setDobType(calculatedAge.ageType);
    }
  };

  const handleGetTimeSlot = (e: FormOnChangeEventType) => {
    const { target } = e;
    const formData = watch();
    reset({
      ...formData,
      timeSlot: null,
    })

    fetchTimeSlot({
      dateSelected: moment
        .utc(formData.startDate as string)
        .format("YYYY-MM-DD"),
      dayId: dayjs.utc(formData.startDate).day(),
      doctorId: target.value.doctorId,
    });
  };

  const handleChangeTimeSlot = (e: FormOnChangeEventType) => {
    console.clear();
    console.log(e.target.value);
    const formData = watch();
    const { startTime, endTime } = e.target.value;
    const date = dayjs.utc(formData.startDate).format("YYYY-MM-DD");
    setSelectedDate({
      startDate: `${date}T${startTime}Z`,
      endDate: `${date}T${endTime}Z`,
    });
    const startDate = `${date}T${startTime}Z`;
    const endDate = `${date}T${endTime}Z`;
    reset({ ...formData, startDate, endDate });
  };

  const handleClose = () => {
    setOpen(false);
    setEditDetails(null);
  };

  const isMonthView =
    timeSlot.slotType === "resourceTimelineMonth" ||
    timeSlot.slotType === "multiMonthYear";


    const {user} = useAuthentication()
    const countrycodegrants= user?.region==="QATAR_REGION"

  const getCountryCodeForForm = () =>
    getCountryCodeForBooking(
      editDetails,
      countries?.response,
      countrycodegrants,
    );

  const handleSetFormData = () => {
    let selectedVisitType = null;
    let times = null;
    let startDate = (
      timeSlot.startTime ? timeSlot.startTime : editDetails?.start
    ) as string;
    let endDate = (
      timeSlot.endTime ? timeSlot.endTime : editDetails?.end
    ) as string;

    if (selectedDate.startDate || selectedDate.endDate) {
      startDate = selectedDate.startDate as string;
      endDate = selectedDate.endDate as string;
    } else {
      setSelectedDate({ startDate, endDate });
    }
    // const noTime = moment.utc(startDate).format("HH:mm:ss") == "00:00:00";
    if (visitType) {
      selectedVisitType = visitType?.response?.find(
        (item) => item.id == editDetails?.visitType?.id
      );
      const startTime = dayjs.utc(startDate).format("hh:mm:ss A");
      const endTime = dayjs.utc(endDate).format("hh:mm:ss A");
      times = `${startTime}-${endTime}`;
      if (
        (
          timeSlot.slotType == "dayGridMonth" ||
          timeSlot.slotType == "multiMonthYear" ||
          bookingSearchParam.department == null ||
          bookingSearchParam.doctor == null) && !Boolean(editDetails?.start)
      ) {
        times = "";
      }
      let age = ""
      if (editDetails?.dob) {
        const calculated = calculateAge(editDetails?.dob);
        setDobType(calculated.ageType)
        age = `${calculated.age}`
      }

      console.log("editDetails => ", editDetails);
      reset({
        ...editDetails,
        age,
        visitType: selectedVisitType as VisitTypesType,

        startDate: timeSlot.lockedDate
          ? timeSlot.startTime
          : startDate,

        endDate: timeSlot.lockedDate
          ? timeSlot.endTime
          : endDate,
        department: timeSlot.lockedDepartment
          ? timeSlot.department
          : bookingSearchParam.department || editDetails?.department,
        doctor: timeSlot.lockedDoctor
          ? timeSlot.doctor
          : bookingSearchParam.doctor || editDetails?.doctor,
        timeSlot: timeSlot.lockedTimeSLot
          ? watch("timeSlot")
          : { times },

        countryCode: getCountryCodeForForm(),

      });

    }
    if (editDetails?.department) {
      fetchDoctorsByDepartment({
        dayId: moment(startDate).day(),
        departmentId: editDetails?.department.departmentId || 0,
        selectedTime: moment(startDate).format("hh:mm:ss"),
      });
    }
    if (editDetails?.doctor) {
      fetchTimeSlot({
        dateSelected: editDetails?.startDate || "",
        dayId: dayjs.utc(editDetails?.startDate).day(),
        doctorId: editDetails.doctor.doctorId || 0,
      });
    }
  };
  const handleFormDataWithoutDetails = () => {
    let startDate = (
      timeSlot.startTime ? timeSlot.startTime : editDetails?.start
    ) as string;
    const department = timeSlot.department ||
      bookingSearchParam.department || null;

    const doctor =
      timeSlot.doctor || bookingSearchParam.doctor || null;

    let { startTime, endTime } = timeSlot;
    if (department) {
      fetchDoctorsByDepartment({
        dayId: moment.utc(timeSlot.startTime).day(),
        departmentId: department.departmentId || 0,
        selectedTime: moment.utc(timeSlot.startTime).format("hh:mm:ss"),
      });
    }
    let times = "";
    if (department && doctor && timeSlot.slotType !== "resourceTimelineMonth" && timeSlot.slotType !== "multiMonthYear") {
      times = `${moment.utc(startTime).format("HH:mm:ss")}-${moment
        .utc(endTime)
        .format("HH:mm:ss")}`;
    }

    if (
      Boolean(department != null && doctor != null) &&
      timeSlot.slotType != "multiMonthYear" &&
      timeSlot.slotType != "resourceTimelineMonth"
    ) {
      times = `${moment.utc(startTime).format("hh:mm:ss A")}-${moment.utc(endTime).format("hh:mm:ss A")}`;
    }
    if (Boolean(department != null && doctor != null)) {
      fetchTimeSlot({
        dateSelected: startDate || "",
        dayId: dayjs.utc(startTime).day(),
        doctorId: doctor?.doctorId || 0,
      });
    }
    console.log("editDetails----->", editDetails)
    reset({
      department,
      doctor,
      startDate: startTime,
      endDate: endTime,
      timeSlot:
        timeSlot.slotType === "resourceTimelineMonth" ||
          timeSlot.slotType === "multiMonthYear"
          ? null
          : { times },

      countryCode: getCountryCodeForBooking(
        null,
        countries?.response,
        countrycodegrants,
      ),
    });
  };
  const isEditBooking = Boolean(editDetails?.id);


  useEffect(() => {
    fetchAllDepattment();
    fetchVisitType();
    return () => {
      setEditDetails(null);
      setSelectedDate({ startDate: null, endDate: null });
    };
  }, []);

  useEffect(() => {
    if (isEditBooking) {
      handleSetFormData();
    } else if (
      timeSlot.slotType &&
      !isEditBooking
    ) {
      handleFormDataWithoutDetails();
    }
  }, [editDetails?.id, timeSlot.startTime, visitType, countries?.response]);

  useEffect(() => {
    if (!open || !editDetails?.id || !countries?.response?.length) return;
    setValue("countryCode", getCountryCodeForForm());
  }, [open, editDetails?.id, editDetails?.countryCodeId, countries?.response]);


  useEffect(() => {
    if (!editDetails?.patientId) {
      setIsTemporaryBooking(true);
      return;
    };
    console.log("editDetails----->", editDetails)
    // ✅ ONLY patient fields
    setValue("patientId", editDetails.patientId);
    setValue("firstName", editDetails.firstName);
    setValue("middleName", editDetails.middleName || "");
    setValue("lastName", editDetails.lastName);
    setValue("gender", editDetails.gender);
    setValue("dob", editDetails.dob);

    if (editDetails.dob) {
      const calculated = calculateAge(editDetails.dob);
      setValue("age", calculated.age.toString());
      setDobType(calculated.ageType);
    } else {
      setValue("age", "");
      setDobType("");
    }

    setValue("mobileNumber", editDetails.mobileNumber || "");
    setValue("email", editDetails.email || "");
    setIsTemporaryBooking(Boolean(editDetails.temporaryBooking));
    setValue("roomNo", editDetails.roomNo || "");
    setValue("countryCode", getCountryCodeForForm());
  }, [editDetails?.patientId, countries?.response]);


  const [isTemporaryBooking, setIsTemporaryBooking] = useState(false);
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="px-4">
        {!Boolean(editDetails?.id) && <PatientSearch />}
      </div>
      <div className={grid}>
        <div className="col-span-full grid sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 items-center">
          <Typography fontWeight={600} color="primary">
            Patient Details
          </Typography>
        </div>
        <CustomFormField
          control={control}
          element="input"
          name="firstName"
          fieldProps={{ label: "First Name", disabled: Boolean(editDetails?.patientId) }}
          rules={{ required: "First Name required" }}
        />
        <CustomFormField
          control={control}
          element="input"
          name="middleName"
          fieldProps={{ label: "Middle Name", disabled: Boolean(editDetails?.patientId) }}
          rules={{ required: false }}
        />
        <CustomFormField
          control={control}
          element="input"
          name="lastName"
          fieldProps={{ label: "Last Name", disabled: Boolean(editDetails?.patientId) }}
          rules={{ required: "Last Name required" }}
        />
        <div
          className={`col-span-full sm:grid-cols-1 grid md:grid-cols-2 lg:grid-cols-2 ${gap}`}
        >
          <div className="flex">
            <StyledTextField>
              <CustomFormField
                control={control}
                name="countryCode"
                element="autocomplete"
                fieldProps={{ label: "Code" }}
                rules={{ required: "Country code required !", onChange: (data) => { console.log(data) } }}
                options={countries?.response || []}
                autocompleteProps={{
                  disabled: Boolean(editDetails?.patientId),
                  getOptionLabel: (option) => option.countryCode,
                  isOptionEqualToValue: (option, value) => option.id == value.id,
                  disableClearable: true,
                  renderOption: (props, option) => (
                    <span  {...props}>
                      {`${option?.isoCode || ""} ${option.countryCode}`}
                    </span>
                  ),
                }}
                loading={countryLoading}
              />
            </StyledTextField>
            <StyledSelect className="w-full">
              <CustomFormField
                control={control}
                element="input"
                name="mobileNumber"
                fieldProps={{ label: "Mobile / Contact number", type: "number", disabled: Boolean(editDetails?.patientId), }}
                rules={{ required: "Mobile number", minLength: { value: 8, message: "Minimum 8 digits reqired" }, maxLength: { value: 13, message: "Maximum 13 digits" } }}
              />
            </StyledSelect>
          </div>
          {/* <CustomFormField
            control={control}
            element="input"
            name="mobileNumber"
            fieldProps={{ label: "Mobile / Contact number",type:"number",disabled:Boolean(editDetails?.patientId),  }}
            rules={{ required: "Mobile number",minLength:{value:8,message:"Minimum 8 digits reqired"},maxLength:{value:13,message:"Maximum 13 digits"} }}
          /> */}
          <CustomFormField
            control={control}
            element="input"
            name="email"
            fieldProps={{ label: "Email", disabled: Boolean(editDetails?.patientId) }}
            rules={{ required: false }}
          />

          {!countrycodegrants && (
          <div
            className={`col-span-full sm:grid-cols-1 grid md:grid-cols-2 lg:grid-cols-2 ${gap}`}
          >
            <CustomFormField
              control={control}
              name="dob"
              element="datepicker"
              fieldProps={{ label: "Date of birth" }}
              calenderProps={{ disabled: Boolean(editDetails?.patientId), maxDate: dayjs() }}
              rules={{ required: false, onChange }}
            />
            <div className="flex gap-3">
              <CustomFormField
                control={control}
                element="input"
                fieldProps={{
                  label: "Age",
                  disabled: Boolean(editDetails?.patientId),
                  InputProps: {
                    endAdornment: dobType,
                  },
                }}
                name="age"
                rules={{ required: false }}
              />
            </div>
          </div>
          )}

          <CustomFormField
            control={control}
            element="radio"
            fieldProps={{ label: "Gender", disabled: Boolean(editDetails?.patientId) }}
            rules={{ required: "Gender required" }}
            name="gender"
            radioProps={{ row: true }}
            radios={[
              { label: "Male", value: "Male" },
              { label: "Female", value: "Female" },
            ]}
          />
        </div>

        <div className="col-span-full">
          <Typography fontWeight={600} color="primary">
            Appointment Details
          </Typography>
        </div>

        <div
          className={`col-span-full sm:grid-cols-1 grid md:grid-cols-2 lg:grid-cols-2 ${gap}`}
        >
          <CustomFormField
            options={department?.response || []}
            loading={departmentLoading}
            control={control}
            element="autocomplete"
            name="department"
            rules={{ required: "Department is required", onChange }}
            autocompleteProps={{
              disabled: timeSlot.lockedDepartment === true,
              isOptionEqualToValue: (option, value) =>
                option.departmentId == value.departmentId,
              getOptionLabel: (option) => option.departmentName,
            }}
            fieldProps={{ label: "Department" }}
          />
          <CustomFormField
            options={doctors?.response || []}
            loading={doctorsLoading}
            control={control}
            name="doctor"
            element="autocomplete"
            fieldProps={{ label: "Doctor" }}
            rules={{
              required: "Doctor is required",
              onChange: handleGetTimeSlot,
            }}
            autocompleteProps={{
              disabled: timeSlot.lockedDoctor === true,
              isOptionEqualToValue: (option, value) => {
                console.log("🔍 comparing:", option, value);
                return option.doctorId === value.doctorId;
              },
              getOptionLabel: (option) => option.doctorName,
            }}
          />
        </div>

        <div className={`col-span-full grid grid-cols-2 ${gap}`}>
          <div className="flex items-end">
            <TextField
              InputProps={{ readOnly: true }}
              label="Date"
              value={
                parseToLocal(timeSlot.startTime || editDetails?.start)?.format(
                  "DD-MM-YYYY (dddd)",
                ) || ""
              }
              disabled={isDateLocked}
            />
          </div>
          <div>
            <CustomFormField
              options={timeSlots?.response || []}
              loading={timeSlotLoading}
              control={control}
              name="timeSlot"
              element="autocomplete"
              fieldProps={{ label: "Time slot" }}
              rules={{
                required: "Time slot required",
                onChange: handleChangeTimeSlot,
              }}
              autocompleteProps={{
                disabled: !isMonthView && timeSlot.lockedTimeSLot === true,
                isOptionEqualToValue: (option, value) =>
                  option.times == value.times,
                getOptionLabel: (option) => option.times,
              }}
            />
          </div>
          <div
            // className={withSlot ? "hidden" : "flex flex-row gap-2 items-center"}
            className="hidden"
          >
            <Controller
              name="startDate"
              rules={{ required: "Start time required" }}
              control={control}
              render={({
                field: { onChange, value = null },
                fieldState: { error },
              }) => (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DateTimePicker"]}>
                    <DateTimePicker
                      label={
                        <span>
                          Start date{" "}
                          <span style={{ color: theme.palette.error.main }}>
                            *
                          </span>
                        </span>
                      }
                      format="hh:mm A"
                      readOnly={true}
                      timezone="UTC"
                      value={value ? dayjs.utc(value) : null}
                      onChange={(date) => {
                        onChange(date);
                      }}
                      slotProps={{
                        textField: {
                          error: !!error,
                          helperText: error?.message,
                          fullWidth: true,
                          InputProps: { readOnly: true },
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              )}
            />
            To
            <Controller
              name="endDate"
              control={control}
              rules={{ required: "End time required" }}
              render={({
                field: { onChange, value = null },
                fieldState: { error },
              }) => (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DateTimePicker"]}>
                    <DateTimePicker
                      // disabled={
                      //   timeSlot.slotType != "dayGridMonth" &&
                      //   timeSlot.slotType != "multiMonthYear"
                      // }
                      label={
                        <span>
                          End date
                          <span style={{ color: theme.palette.error.main }}>
                            *
                          </span>
                        </span>
                      }
                      format="hh:mm A"
                      readOnly={true}
                      timezone="UTC"
                      value={value ? dayjs.utc(value) : null}
                      onChange={(date) => {
                        onChange(date);
                      }}
                      slotProps={{
                        textField: {
                          error: !!error,
                          helperText: error?.message,
                          InputProps: { readOnly: true },
                        },
                      }}
                    />
                  </DemoContainer>
                </LocalizationProvider>
              )}
            />
          </div>
        </div>

        <div
          className={`col-span-full sm:grid-cols-1 grid md:grid-cols-2 lg:grid-cols-2 ${gap}`}
        >
          <CustomFormField
            options={visitType?.response || []}
            loading={visitTypesLoading}
            control={control}
            element="autocomplete"
            name="visitType"
            fieldProps={{ label: "Visit Type" }}
            rules={{ required: "Visit Type required" }}
            autocompleteProps={{
              getOptionLabel: (option: any) => option?.visitType || "",
              isOptionEqualToValue: (option: any, value: any) => {
                if (!value || value === "") return false;
                return (option.id || option.visitTypeId) === (value.id || value.visitTypeId);
              }
            }}
          />
          <CustomFormField
            name="roomNo"
            control={control}
            element="autocomplete"
            options={[1,2,3,4,5,6]}
            rules={{ required: false }}
            fieldProps={{ label: "Allocated Room" }}
            autocompleteProps={{
              getOptionLabel: (option: any) => option || "",
              isOptionEqualToValue: (option: any, value: any) => {
                if (!value || value === "") return false;
                return option == value;
              },
              filterOptions: (options, params) => {
                const filter = createFilterOptions<any>();
                const filtered = filter(options, params);
                if (filtered.length == 0 && params.inputValue !== "") {
                  return [Number(params.inputValue)]
                }
                return filtered;
              }
            }}
          />
          <CustomFormField
            name="notes"
            control={control}
            element="input"
            rules={{ required: false }}
            fieldProps={{ label: "notes" }}
          />
        </div>

        <div className={`col-span-full flex justify-end items-center  ${gap}`}>
          {!Boolean(editDetails?.patientId) && <div className="flex items-center gap-2">
            <input
              type="checkbox"
              id="tempBooking"
              checked={isTemporaryBooking}
              onChange={(e) => setIsTemporaryBooking(e.target.checked)}
            />
            <label htmlFor="tempBooking" className="text-sm text-gray-700">
              Temporary booking
            </label>
          </div>}

          <Button
            type="submit"
            size="small"
            variant="contained"
            color="success"
            disabled={saveLoading}
            endIcon={
              saveLoading && <CircularProgress color="success" size={18} />
            }
          >
            submit
          </Button>
          <Button
            onClick={handleClose}
            size="small"
            variant="contained"
            color="error"
          >
            cancel
          </Button>
        </div>
      </div>
    </form>
  );
}
export default BookingForm;
